import { render, staticRenderFns } from "./activateEmail.vue?vue&type=template&id=2438cd06&"
import script from "./activateEmail.vue?vue&type=script&lang=js&"
export * from "./activateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports